<template>
    <v-dialog v-model="dialogo" width="90%">
        <v-card>
            <v-card-title class="subtitle-1 primary white--text">
                Importar Base de Filiais
            </v-card-title>
            <v-card-text>
                <v-btn
                    color="primary"
                    @click="exportarModelo()"
                    class="my-3"
                >
                    <v-icon left>mdi-microsoft-excel</v-icon>
                    Baixar modelo de importação
                </v-btn>
                <v-alert
                    text
                    type="info"
                    border="left"
                    style="font-size: 12px;"
                >
                    <ul>
                        <li>
                            A base utilizada para importação deve ser parecida
                            ao modelo extraído acima (Modelo de Importação).
                        </li>
                        <li>
                            A coluna <strong>ID Java</strong> é obrigatória
                            (<strong>e o nome deve ser idêntico ao da base exportada</strong>),
                            as demais colunas podem ser excluídas.
                        </li>
                        <li>
                            Só é indicado alterações na coluna
                            <strong>Quantidade</strong>.
                            <strong>Se outra coluna for alterada a linha pode ser desconsiderada.</strong>
                        </li>
                        <li>
                            Para adicionar uma <strong>filial</strong> ao
                            <strong>acordo</strong>, adicione <strong>1</strong>
                            na coluna <strong>Quantidade</strong> para a filial desejada.
                        </li>
                        <li>
                            Para remover uma <strong>filial</strong> do
                            <strong>acordo</strong>, adicione <strong>0</strong>
                            na coluna <strong>Quantidade</strong> para a filial desejada.
                        </li>
                        <li>
                            Tudo que for diferente de <strong>1</strong> na coluna
                            <strong>Quantidade</strong> será considerado como
                            <strong>0</strong> (filial não selecionada).
                        </li>
                    </ul>
                </v-alert>
                <v-row no-gutters>
                    <v-col cols="8" class="px-2">
                        <v-form v-model="isCsv">
                            <v-file-input
                                label="Arquivo CSV"
                                outlined
                                dense
                                v-model="csvModelo"
                                :rules="regra.csv"
                                accept=".csv"
                            ></v-file-input>
                        </v-form>
                    </v-col>
                    <v-col cols="4" class="px-2">
                        <v-btn
                            color="primary"
                            :disabled="!isCsv"
                            @click="importarFiliais()"
                        >
                            <v-icon left>mdi-upload</v-icon>
                            Importar Filiais
                        </v-btn>
                    </v-col>
                </v-row>
                <v-alert
                    type="error"
                    transition="scale-transition"
                    dismissible
                    v-model="alerta"
                >
                    {{ alertaMesagem }}
                </v-alert>
                <v-expand-transition>
                    <div v-show="erroModelo">
                        <v-row no-gutters class="mb-0">
                            <v-col cols="6">
                                <download-csv
                                    :data="listaErro"
                                    :labels="listaErroLabels"
                                    name="erros.csv"
                                    delimiter=";"
                                >
                                    <v-btn color="primary">
                                        <v-icon left>mdi-microsoft-excel</v-icon>
                                        Exportar Erros
                                    </v-btn>
                                </download-csv>
                            </v-col>
                            <v-col cols="6" align="end">
                                <v-btn
                                    color="primary"
                                    @click="ignorarErrosFiliais()"
                                >
                                    <v-icon left>mdi-alert-remove</v-icon>
                                    Ignorar Erros
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="HeaderErro"
                            :items="listaErro"
                            :items-per-page="5"
                            :options.sync="paginationErro"
                            class="elevation-0 data-table-2"
                        ></v-data-table>
                    </div>
                </v-expand-transition>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="dialogo = false"
                >
                    <v-icon left>mdi-close</v-icon>
                    Fechar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-dialog>
</template>

<script>
export default {
    name: "importarFiliaisGC",
    data() {
        return {
            carregando: false,
            acordo: {},
            dados: [],
            dadosTemp: [],
            dialogo: false,
            csvModelo: null,
            isCsv: false,
            alerta: false,
            alertaMesagem: null,
            HeaderErro: [
                { text: "Descrição do Erro", value: "msg", align: "left" },
            ],
            listaErro: [],
            listaErroLabels: { msg: "Descrição do Erro" },
            erroModelo: false,
            paginationErro: {},
            regra: {
                csv: [
                    (v) => !!v || "Selecione um arquivo.",
                    (v) =>
                        (v &&
                            [".csv", ".CSV"].includes(v.name.substr(-4))) ||
                        "O arquivo deve ser do tipo CSV.",
                ],
            },
        };
    },
    methods: {
        exportarModelo() {
            this.$emit("exportarModelo");
        },
        getPeriodo() {
            const periodo = (this.acordo.periodo || []).map((e) => {
                const mes = new Date(e + "-15");
                return "quantidade_" + mes.getFullYear() + "_" + (mes.getMonth() + 1);
            });
            return periodo;
        },
        temDisponibilidade(item, periodo) {
            // O espaço das filiais que já estão no acordo em edição é dele: seguem liberadas
            const filiaisDoAcordo = (this.acordo.filiaisAcordo || []).map((f) => f.id_filial);
            if (filiaisDoAcordo.includes(item.id_filial)) return true;

            const periodoMatch = periodo.match(/_(\d{4})_(\d+)$/);
            if (!periodoMatch) return false;

            const ano = periodoMatch[1];
            const mes = periodoMatch[2].padStart(2, "0");
            const oportunidade = item[`oportunidade_${ano}_${mes}`];

            return oportunidade !== undefined && oportunidade !== null && oportunidade > 0;
        },
        nomePeriodo(periodo) {
            const periodoMatch = periodo.match(/_(\d{4})_(\d+)$/);
            if (!periodoMatch) return periodo;

            return periodoMatch[2].padStart(2, "0") + "/" + periodoMatch[1];
        },
        abrir(acordo, dados) {
            this.dados = dados.map((a) => ({ ...a }));
            this.acordo = { ...acordo };
            this.csvModelo = null;
            this.alerta = false;
            this.alertaMesagem = null;
            this.erroModelo = false;
            this.listaErro = [];
            this.dadosTemp = [];
            this.dialogo = true;
        },
        async importarFiliais() {
            this.alerta = false;
            this.alertaMesagem = null;
            this.erroModelo = false;
            this.listaErro = [];
            this.dadosTemp = [];

            const parseCsv = async (csv) => {
                return new Promise((resolve) => {
                    this.$papa.parse(csv, {
                        delimiter: ";",
                        header: true,
                        dynamicTyping: true,
                        skipEmptyLines: true,
                        complete: function (results) {
                            resolve(results);
                        },
                    });
                });
            };

            var csv = await parseCsv(this.csvModelo);

            if (csv.errors.length) {
                this.alerta = true;
                this.alertaMesagem =
                    "Erro ao ler o arquivo CSV. Exporte novamente o modelo e importe o modelo editado.";
            } else {
                this.dadosTemp = this.dados.map((a) => ({ ...a }));

                // Desmarca todas as filiais para todos os períodos
                for (const f of this.dadosTemp) {
                    for (const campo of this.getPeriodo()) {
                        f[campo] = false;
                    }
                }

                var linha = 2;
                var erroLinha = null;

                for (const e of csv.data) {
                    erroLinha = " - Erro linha " + linha;
                    linha++;

                    // Busca pelo ID Java (coluna "ID Java" do CSV)
                    var idJava = e["ID Java"];

                    var index = this.dados.findIndex(
                        (element) => element.id_java == idJava
                    );

                    if (index >= 0) {
                        // Se Quantidade === 1, marca todos os períodos
                        if (e["Quantidade"] === 1) {
                            for (const campo of this.getPeriodo()) {
                                if (this.temDisponibilidade(this.dadosTemp[index], campo)) {
                                    this.dadosTemp[index][campo] = true;
                                } else {
                                    this.listaErro.push({
                                        msg:
                                            `A filial (ID Java = ${idJava}) não tem espaço disponível em ${this.nomePeriodo(campo)} e não foi marcada.` +
                                            erroLinha,
                                    });
                                }
                            }
                        } else {
                            // Se Quantidade !== 1, desmarca todos os períodos
                            for (const campo of this.getPeriodo()) {
                                this.dadosTemp[index][campo] = false;
                            }
                        }
                    } else {
                        this.listaErro.push({
                            msg:
                                `A filial (ID Java = ${idJava}) não foi encontrada.` +
                                erroLinha,
                        });
                    }
                }

                if (this.listaErro.length > 0) {
                    this.paginationErro.page = 1;
                    this.erroModelo = true;
                } else {
                    this.dados = this.dadosTemp.map((a) => ({ ...a }));

                    this.$emit("importar");

                    this.dialogo = false;
                }
            }
        },
        ignorarErrosFiliais() {
            this.dados = this.dadosTemp.map((a) => ({ ...a }));

            this.$emit("importar");

            this.dialogo = false;
        },
    },
};
</script>
